module.exports = __webpack_public_path__ + "img/icon-finish.29195677.png";